<div class="flex flex-row justify-between w-full h-10 sticky top-0 bg-white z-50 px-6 py-1">
  <div>
    <p class="text-[#53565B] text-base mb-0 font-semibold"  style="line-height: 32px !important">
    {{loginStateObject?.first_name + ' ' + loginStateObject?.last_name}}’s Inbox · {{ is_file_loading ? '': inboxFiles.length + ' item'}}{{inboxFiles.length>1?'s':''}} </p>
  </div>
  <div>
    <div class="app__centered-item w-full h-full px-5 border-solid border border-[#53565B38]">
      <span class="mt-[-2px] text-[#5475C0]"><img src="assets/images/blue-search-icon.svg" width="16px" height="16px" /></span>
      <input
        class="h-full w-full ml-2 border-none outline-none text-[13px] italic"
        type="text"
        [(ngModel)]="searchText"
        placeholder="Search inbox"
        (input)="onInputChange($event.target.value)"
        />
      </div>
    </div>
  </div>

  @if (!is_file_loading) {
    <div class="example-list overflow-auto p-6 mb-6"   style="width: 100%; display: flex; flex-wrap: wrap;">
      @for (file of filteredItems; track file; let i = $index) {
        <div style="width: 196px" class=" cursor-pointer flex mb-[16px] mr-[16px]">
          <div
            style="border-radius: 8px; z-index: 0"
            (click)="file.selected = !file.selected"
            [style.border-color]="file.selected? '#1AA140 !important':''"
            class="flex justify-between flex-col border border-[#d3dce8] bg-[#FFFFFF] w-full h-[112px] box-border hover:border-[#25508E] border-2"
            >
            <div style="z-index: 0" class="flex justify-between flex-col">
              <div class="flex flex-col" [style.background]="file.selected ? '#EFFFF7' : ''" style="border-radius: 8px 8px 0px 0px;">
                @if (file.selected) {
                  <img style="height: 67px;"   src="assets/images/discovery/selected.svg" alt="" >
                }
                <file-preview-setup
                  [style.visibility]="file.selected ?  'hidden' : 'visible' "
                  [style.height]="file.selected ? '0px !important' : '68px !important'"
                  [file]="file"
                  [IconName]="file | iconName"
                  [currentuserId]="currentuserId"
                  #fileExtensionComponentchild
                  >
                </file-preview-setup>
              </div>
              <div class="flex justify-between border border-[#d3dce8]"
                style="border-radius: 0px 0px 8px 8px; background: white; z-index: 1;position: relative;top: -8px;">
                @if (file.status == 'Done') {
                  <p style="max-width: 76%; margin: 0px;line-height: 48px !important;" class="text-truncate text-[##010b18] leading-9 font-bold text-sm pl-[12px]">
                    {{ file.file_name?.length > 15 ? file.file_name?.slice(0, 15) + '...' : file.file_name?.slice(0, 15) }}
                  </p>
                }
                @if (file.status == 'Done') {
                  <div class="popup-menu">
                    <button
                      class="more-vote-btn"
                      (click)="$event.stopPropagation()"
                      mat-icon-button
                      [matMenuTriggerFor]="menuItem"
                      [disableRipple]="true"
                      >
                      <span class="material-icons" style="position: relative; left: 12px">more_vert</span>
                    </button>
                    <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
                      <button style="width: 185px" (click)="renameFolder(file, i)" mat-menu-item class="text-[#000] leading-3 text-sm font-normal">
                        <span
                          style="margin: 0 9px; position: relative; top: 4px"
                          class="text-[#25508e] material-icons material-icons-round menuitem-icon"
                          >edit</span
                          >
                          Rename
                        </button>
                        <button
                          style="width: 185px"
                          (click)="deleteAttachment(i, file.id, file.file_name)"
                          mat-menu-item
                          class="text-[#000] leading-3 text-sm font-normal"
                          >
                          <span
                            style="margin: 0 9px; position: relative; top: 4px"
                            class="text-[#25508e] material-icons material-icons-round menuitem-icon"
                            >delete</span
                            >
                            Delete
                          </button>
                        </mat-menu>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>

      } @else {

        <div class="p-6 mb-6">
          <!-- *ngIf="loader$ | async" -->
          <div class="loader-container">
            @for (item of loaderItems; track item) {
              <div>
                <div class="flex loader-body" id="{{ item.id }}">
                  <div class="ph-item width-100per loader-body-item" style="width: 196px;height: 120px;" >
                    <div class="ph-col-12 p-0">
                      <div class="ph-row">
                        <div class="ph-col-12" style="height: 72px;margin-top: 0px;border-radius: 8px;"  ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

      }

